import React from 'react';
import { Button } from 'rsuite';

const ExistingSchedulesDisplay = ({ 
    existingSchedules, 
    getColorForType,
    canManage = false,
    onRemoveSchedule
}) => {
    if (!existingSchedules || existingSchedules.length === 0) {
        return null;
    }

    return (
        <div style={{ 
            marginBottom: 20, 
            padding: '10px', 
            backgroundColor: '#f8f9fa', 
            borderRadius: '4px' 
        }}>
            <label style={{ 
                fontWeight: 'bold', 
                marginBottom: '5px', 
                display: 'block' 
            }}>
                已排班：
            </label>
            <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: '8px' 
            }}>
                {existingSchedules.map((schedule, index) => (
                    <div
                        key={schedule.id || index} 
                        style={{
                            backgroundColor: getColorForType(schedule.type_id),
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}
                    >
                        <span>
                            {schedule.user_name} ({schedule.type_name}) {schedule.time_range}
                        </span>
                        {canManage && onRemoveSchedule && (
                            <Button
                                size="xs"
                                color="red"
                                appearance="subtle"
                                onClick={() => onRemoveSchedule(schedule.id)}
                                style={{
                                    minWidth: '20px',
                                    height: '20px',
                                    padding: '0',
                                    fontSize: '10px',
                                    lineHeight: '1',
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                    border: 'none'
                                }}
                                title="移除此班表"
                            >
                                ×
                            </Button>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ExistingSchedulesDisplay;
